<!--动态内容布局-->
<template>
  <div class="main">
    <div v-if="voice" class="voice">
      <audio :id="`audio-${voice.resource}`">
        <source id="tts_source_id" :src="`/api/resource/resource/resource/download/${voice.resource}`"
                type="audio/mpeg">
        <embed id="tts_embed_id" height="0" width="0" src="">
      </audio>
      <div class="voice-box voice-box" v-on:click="playVoice(`audio-${voice.resource}`)">
        <img src="../../../assets/images/common/voice.svg" alt="">
        <span>
                    {{ voice.duration }} ″
                </span>
        <span class="stop" v-if="voiceStatus['audio-'+voice.resource]">
                    <i class="el-icon-video-pause"></i>
                </span>
        <span class="stop" v-else>
                    <i class="el-icon-video-play"></i>
                </span>
      </div>
    </div>
    <div v-if="text" :class="`text text-${size}`">
      {{ text }}
    </div>
    <div v-if="resource" class="resource">
      <div :class="resource.length === 1?'resourceImgLength1':'resourceImgGt1' + ' resourceBox'">
          <span v-on:click="showOpenAppModal()" v-for="(item,index) in resource" :key="index" class="resourceItem">
             <span class="video" v-if="item.type === 'ResourceType.Video'">
                 <img src="../../../assets/images/common/player.svg" alt="">
                  <img :src="`/api/resource/resource/resource/download/${item.resource}?imgStyleName=gif`">
               <div class="video-time">{{ format(item.duration) }}</div>
             </span>
              <span v-else>
                  <img :src="`/api/resource/resource/resource/download/${item.resource}?imgStyleName=no_watermark_compress`">
              </span>
          </span>
      </div>
    </div>
    <div class="modal" :hidden="modalHidden">
      <div class="modal-background"></div>
      <div class="modal-body">
        <div class="modal-body-close" v-on:click="closeOpenAppModal()">
          <img src="../../../assets/images/common/close.svg">
        </div>
        <img class="modal-body-cover" src="../../../assets/images/common/cover.png">
        <span class="modal-body-content">
                打开足趣社区查看高清图片/视频/语音
            </span>
        <div v-on:click="onDownClick()" class="downloadButton modal-body-button">打开APP</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      // 语音播放状态
      voiceStatus: {},
      // 模态框是否显示
      modalHidden: true,
    };
  },
  props: {
    // 大小，只支持:[Big,Small]
    size: {
      default: 'Big',
    },
    // 文本内容
    text: [String],
    // 语音内容
    voice: [Object],
    // 资源图片
    resource: [Array],
    // 下载按钮点击事件
    onDownClick: [Function],
  },
  methods: {
    // 播放语音
    playVoice(id) {
      let voice = document.getElementById(id);

      // 停止播放语音事件
      let stopPlayVoice = (id) => {
        this.voiceStatus[id] = false;
        this.voiceStatus = {...this.voiceStatus};
      };


      // 播放/停止
      if (voice.paused) {
        voice.play();
        this.voiceStatus[id] = true;
        this.voiceStatus = {...this.voiceStatus};
      } else {
        voice.pause();
        voice.currentTime = 0;
        stopPlayVoice(id);
      }

      // 结束播放监听器
      voice.addEventListener('ended', () => {
        stopPlayVoice(id);
      }, false);
    },
    // 弹出打开App模态框
    showOpenAppModal() {
      this.modalHidden = false;
    },
    // 关闭打开App模态框
    closeOpenAppModal() {
      this.modalHidden = true;
    },
    // 时间格式化
    format(time) {
      if (time === null) return;
      const push0 = str => str <= 9 ? '0' + str : str;
      return `${push0(parseInt(time / 60 / 60))}:${push0(parseInt(time / 60 % 60))}:${push0(time % (60))} `
    }
  }
}
</script>

<style scoped>
.main div {
  margin-top: 1rem;
}

.text {
  color: #666;
  word-wrap: break-word;
  word-break: break-all;
}

.text-Big {
  font-size: 16px;
}

.text-Small {
  font-size: 14px;
}

.voice .voice-box {
  width: 50%;
  border-radius: 10px;
  background: -webkit-gradient(linear, 0 0, 0 bottom, from(#A081FF), to(#A081FF));
  display: flex;
  align-items: center;
  color: #FFF;
  padding: 5px 10px;
}

.voice .voice-box .stop {
  display: inline-block;
  flex: 1;
  text-align: right;
  font-size: 20px;
}

.voice .voice-box img {
  height: 1.0rem;
  margin-right: 10px;
}

.voice .voice-box span {
  font-size: 14px;
}

.resource img {
  object-fit: cover;
  border-radius: 3px;
}

.resource .video {
  position: relative;
}

.video-time {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #FFF;
  font-size: 16px;
}

.resource .video img:first-child {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  object-fit: none;
}

.resourceBox {
  display: flex;
  width: 100%;
}

.resourceItem {
  flex: 1;
  padding: 5px;
}

.resourceItem > span {
  display: inline-block;
  height: 100%;
  width: 100%;
}

.resourceItem img {
  width: 100%;
  height: 100%;
}

.resourceImgLength1 span span {
  height: 300px;
}

.resourceImgGt1 span span {
}

.modal {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: -100px;
  z-index: 999;
}

.modal-background {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
}

.modal-body {
  position: absolute;
  width: 80%;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  max-width: 400px;
}

.modal-body-close {
  position: absolute;
  right: 10px;
}

.modal-body-close img {
  width: 25px;
}

.modal-body-cover {
  height: 200px;
  width: 100%;
}

.modal-body-content {
  display: inline-block;
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: #303133;
}

.modal-body-button {
  width: 80%;
  padding: 10px;
  background: linear-gradient(270deg, rgba(118, 75, 248, 1) 0%, rgba(187, 58, 246, 1) 100%);
  opacity: 1;
  border-radius: 50px;
  font-size: 20px;
  color: #FFF;
  text-align: center;
  margin: 20px auto;
}
</style>
